import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WaitDialog, {
      isActive: $setup.loading,
      title: "Loading RSM data..."
    }, null, 8 /* PROPS */, ["isActive"]),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createCommentVNode(" Summary grid "),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "text-left" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      headers: $setup.headers,
                      items: $setup.summaryRows,
                      loading: $setup.loading,
                      density: "comfortable",
                      class: "elevation-0",
                      "no-data-text": "No data returned",
                      "items-per-page": "-1",
                      "hide-default-footer": "",
                      hover: ""
                    }, {
                      top: _withCtx(() => [
                        _createVNode(_component_v_toolbar, { flat: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar_title, null, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("RSM Management")
                              ])),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_divider, {
                              class: "mx-4",
                              inset: "",
                              vertical: ""
                            }),
                            _createVNode(_component_m_btn, {
                              color: "primary",
                              "prepend-icon": "mdi-refresh",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.loadSummary($setup.selectedEnvironment)))
                            }, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createTextVNode(" Refresh ")
                              ])),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      "item.actions": _withCtx(({ item }) => [
                        _createVNode(_component_v_btn, {
                          icon: "",
                          size: "small",
                          variant: "text",
                          color: "error",
                          loading: $setup.deletingRegCode === item.salesField,
                          disabled: $setup.loading || $setup.deletingRegCode !== null,
                          title: `Delete ${item.salesField}`,
                          onClick: ($event: any) => ($setup.deleteRow(item.salesField))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-trash-can-outline")
                              ])),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["loading", "disabled", "title", "onClick"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["headers", "items", "loading"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" Input row "),
        _createVNode(_component_v_row, { class: "mt-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "text-left" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  ref: "firstFieldRef",
                                  modelValue: $setup.inputMktDesc,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputMktDesc) = $event)),
                                  label: "DMM / RSM",
                                  placeholder: "Person name",
                                  density: "comfortable",
                                  variant: "outlined",
                                  "hide-details": "",
                                  disabled: $setup.loading,
                                  onKeydown: _withKeys(_withModifiers($setup.addRow, ["prevent"]), ["enter"])
                                }, null, 8 /* PROPS */, ["modelValue", "disabled", "onKeydown"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: $setup.inputRegCode,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.inputRegCode) = $event)),
                                  label: "Sales Field",
                                  placeholder: "e.g. 01",
                                  density: "comfortable",
                                  variant: "outlined",
                                  "hide-details": "",
                                  disabled: $setup.loading,
                                  onKeydown: _withKeys(_withModifiers($setup.addRow, ["prevent"]), ["enter"])
                                }, null, 8 /* PROPS */, ["modelValue", "disabled", "onKeydown"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: $setup.inputRegDesc,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.inputRegDesc) = $event)),
                                  label: "Sales Field Name",
                                  placeholder: "Region description",
                                  density: "comfortable",
                                  variant: "outlined",
                                  "hide-details": "",
                                  disabled: $setup.loading,
                                  onKeydown: _withKeys(_withModifiers($setup.addRow, ["prevent"]), ["enter"])
                                }, null, 8 /* PROPS */, ["modelValue", "disabled", "onKeydown"])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, { class: "text-caption text-medium-emphasis pt-2 pb-3" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "x-small",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode("mdi-information-outline")
                          ])),
                          _: 1 /* STABLE */
                        }),
                        _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Sales Field", -1 /* HOISTED */)),
                        _cache[9] || (_cache[9] = _createTextVNode(" is required — it links the DMM and Sales Field Name together. The DMM / RSM with the Sales Field, assigns a name, or changes the existing name. Provide all three fields to create a new entry, or change all of an existing entry. "))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}